<app-header></app-header>
<mat-card>
    <mat-card-content>
      <div class="header">
        <b>RESET PASSWORD</b>
      </div>
      <form (ngSubmit)="resetPassword()" name="loginForm" [formGroup]="loginForm">
        <div class="email-input">
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Email</mat-label>
            <input formControlName="email" matInput required name="email" [(ngModel)]="user.email">
            <mat-error *ngIf="loginForm.get('email').errors?.required">
               Email required
            </mat-error>
          </mat-form-field>
        </div>
        <div>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Password</mat-label>
            <input formControlName="password" matInput [type]="hide ? 'password' : 'text'" required name="password" [(ngModel)]="user.password"/>
            <button type="button"
                    mat-icon-button
                    matSuffix
                    (click)="hide = !hide"
                    [attr.aria-label]="'Hide Password'"
                    [attr.aria-pressed]="hide">
                <mat-icon>{{ hide?"visibility_off":"visibility" }}</mat-icon>
              </button>
              <mat-error *ngIf="loginForm.get('password').errors?.required">
                Password Required
              </mat-error>
          </mat-form-field>
        </div>

        <div>
            <mat-form-field class="full-width" appearance="outline">
              <mat-label>Confirm Password</mat-label>
              <input formControlName="confirmPassword" matInput [type]="chide ? 'confirmPassword' : 'text'" required name="confirmPassword"/>
              <button type="button"
                      mat-icon-button
                      matSuffix
                      (click)="chide = !chide"
                      [attr.aria-label]="'Hide Password'"
                      [attr.aria-pressed]="chide">
                  <mat-icon>{{ chide?"visibility_off":"visibility" }}</mat-icon>
                </button>
                <mat-error *ngIf="loginForm.get('confirmPassword').errors?.required">
                  Required Password
                </mat-error>
            </mat-form-field>
          </div>
        <button mat-flat-button color="primary">Submit</button>
        <a mat-list-item routerLink="/login" routerLinkActive="list-item-active">
          <span>Login</span>
      </a>
      </form>

    </mat-card-content>
  </mat-card>
